import { FC } from 'react';
import { key, partTestId } from '@connect-x-app/shared-utils';
import classnames from 'classnames';

import { Text } from '../Text/Text';
import { ToggleProps } from './Toggle.shared';

import './Toggle.scss';

export const Toggle: FC<ToggleProps> = ({ onChange, testId, toggleValue, valueOptions }) => {
  const getOptionClassName = (option: string) => {
    return classnames('toggle__option', {
      'toggle__option--active': toggleValue === option,
    });
  };

  const handleClick = (value: string) => {
    if (value !== toggleValue) {
      onChange(value);
    }
  };

  const renderOptionButtons = valueOptions.map((value: string) => {
    return (
      <button
        className={getOptionClassName(value)}
        data-test={partTestId(testId, key(value))}
        key={value.toLowerCase()}
        onClick={() => handleClick(value)}
        type="button"
      >
        <Text as="span" lineHeight={1.2} size="XS" weight="bold">
          {value}
        </Text>
      </button>
    );
  });

  return (
    <div className="toggle" data-test={testId}>
      <div className="toggle__container">{renderOptionButtons}</div>
    </div>
  );
};
